import arrayMove from 'array-move'

import {
    UserDashboardsDocument as getDashboardsQuery,
    UpdateUserDashboardsDocument as updateDashboardsMutation,
    UserDashboardsQuery,
    MutationResolvers,
} from '../../../../generated/graphql'
import type { ApolloResolverContext } from '@edge/spark/io-apollo'

const reorderUserDashboards: MutationResolvers<ApolloResolverContext>['reorderUserDashboards'] = async (
    _root,
    { id, index },
    { client },
) => {
    console.debug('io-dashboards reorderUserDashboards Deprecated, refactor (soon)')

    if (!id) {
        throw new Error('Missing ID')
    }

    if (!Number.isInteger(index) || Math.sign(index) === -1) {
        throw new Error('Missing index')
    }

    if (!client) {
        throw new Error('No ApolloClient Context')
    }

    // @todo: reorder other user?
    const { data } = await client.query<UserDashboardsQuery>({
        query: getDashboardsQuery,
        fetchPolicy: 'cache-first',
    })

    const dashboards = data?.user?.dashboards

    if (!dashboards || !dashboards.length) {
        throw new Error('No Prior Dashboards')
    }

    const priorIndex = dashboards.findIndex((d) => JSON.parse(d || '{}').id === id)

    if (priorIndex === index) {
        return false
    }

    if (priorIndex === -1) {
        throw new Error('Dashboard not found')
    }

    const updatedDashboards = arrayMove(dashboards, priorIndex, index)

    await client.mutate({
        mutation: updateDashboardsMutation,
        variables: { dashboards: updatedDashboards },
        refetchQueries: ['UserProfileOptions'],
        optimisticResponse: {
            updateUser: {
                authenticationId: null,
                statusCode: 200,
                statusMessage: null,
                __typename: 'UserMutationResponse',
            },
        },
        update: (store): void => {
            store.writeData({
                data: {
                    'dashboards({})': updatedDashboards,
                    user: {
                        __typename: 'User',
                        dashboards: updatedDashboards,
                    },
                },
            })
        },
    })

    return true
}

export default reorderUserDashboards
